import React from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import s from "./ProjectDetails.module.scss";
import { useSelector } from "react-redux";
import moment from "moment";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";
import ReactPlayer from "react-player";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Link } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";

const ProjectDetails = () => {
  const project = useSelector(
    (state) => state.application.approvedProjectDetails
  );
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const { width } = useWindowDimensions();
  return (
    <div>
      {width > 1130 ? <Header /> : <MobileHeader />}
      <Link to={"/approvedProjects"} className={s.back}>
        <ArrowLeftOutlined className={s.backIcon} /> &nbsp;&nbsp;Назад
      </Link>
      <div className={s.content}>
        <div>
          <Carousel
            showThumbs={true}
            showStatus={false}
            autoPlay={true}
            className="my-carousel"
          >
            {project?.project_images?.map((it) => (
              <div>
                <img src={it.file} className={s.img} />
              </div>
            ))}
          </Carousel>
        </div>
        <div className={s.title}>{project?.title}</div>
        <div className={s.header}>
          <div className={s.category}>
            {project?.project_field.toUpperCase()}
          </div>
          <div className={s.date}>
            {moment(project?.created_at).format("DD.MM.YYYY")}г.
          </div>
        </div>

        <div
          className={s.description}
          dangerouslySetInnerHTML={{ __html: project?.body }}
        ></div>
      </div>
      <div className={s.video}>
        {project?.project_videos?.map((it) => (
          <div className={s.video_item}>
            <ReactPlayer
              url={it?.video_url}
              config={{
                youtube: {
                  playerVars: { showinfo: 1 },
                },
                facebook: {
                  appId: "12345",
                },
              }}
              controls={true}
              width={"100%"}
            />
          </div>
        ))}
      </div>

      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default ProjectDetails;
